
import React, { useState } from "react";
import { Dialog } from 'primereact/dialog';

export const DialogMaximize = ({visible,header, onClose,body,maximizable=false})=> {
    return (
        <div className="card w-full flex justify-content-center">
            <Dialog header={header} visible={visible} maximizable={maximizable} closeOnEscape={false} dismissableMask={false} onHide={() => {onClose()}}>
                {body}
            </Dialog>
        </div>
    )
}
        